/**
 * PostHog Tracking - Bernard Miniatures
 */

(function() {
  'use strict';

  function saveDistinctIdToCart() {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { posthog_distinct_id: posthog.get_distinct_id() } })
    });
  }

  function interceptCheckoutButtons() {
    const handleCheckoutClick = async (e) => {
      const btn = e.target.closest('[name="checkout"], .shopify-payment-button button, [data-shopify="payment-button"] button');
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();

      await saveDistinctIdToCart();

      const form = btn.closest('form');
      if (form && form.action && form.action.includes('/cart')) {
        // requestSubmit(btn) preserves the submit button's name="checkout" so Shopify redirects to checkout rather than /cart
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit(btn);
        } else {
          form.submit();
        }
      } else {
        window.location.href = '/checkout';
      }
    };

    document.addEventListener('click', handleCheckoutClick, true);

    const observer = new MutationObserver(() => {
      // Re-apply to dynamically added buttons (Shopify payment buttons load async)
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function track(event, props) {
    posthog.capture(event, props);
  }

  function getPageType() {
    const path = window.location.pathname;
    if (path === '/') return 'homepage';
    if (path.includes('/products/')) return 'product';
    if (path.includes('/collections/')) return 'collection';
    if (path.includes('/cart')) return 'cart';
    return 'other';
  }

  function getSectionType(el) {
    const parent = el.parentElement;
    if (!parent) return null;
    if (parent.closest('.featured-collection')) return 'featured_collection';
    if (parent.closest('#homepage-recommendations')) return 'homepage_recommendations';
    if (parent.closest('.homepage-reco-content')) return 'homepage_recommendations';
    if (parent.closest('product-recommendations')) return 'product_recommendations';
    if (parent.closest('#visitor-recommendations')) return 'visitor_recommendations';
    if (parent.closest('[id*="visitor-recommendations"]')) return 'visitor_recommendations';
    if (parent.closest('.oos-section')) return 'out_of_stock_recommendations';
    if (parent.closest('recently-viewed-products')) return 'recently_viewed';
    return null;
  }

  function init() {
    // Identify logged-in customers
    if (window.shopifyCustomer?.id) {
      posthog.identify(window.shopifyCustomer.id, { email: window.shopifyCustomer.email });
    }

    // Save distinct_id to cart ONLY when cart has items (on cart actions)
    // NOT on page load - Shopify regenerates empty carts on every page refresh

    // Intercept checkout buttons to ensure distinct_id is saved before checkout
    interceptCheckoutButtons();

    // Re-save on cart actions (when cart is stable)
    document.addEventListener('cart:item-added', saveDistinctIdToCart);
    document.addEventListener('cart-drawer:open', saveDistinctIdToCart);

    // Track add to cart
    document.addEventListener('cart:item-added', function(e) {
      const p = e.detail?.product;
      if (p) {
        track('cart:item_added', {
          product_id: p.product_id || p.id,
          product_name: p.product_title || p.title,
          variant_id: p.variant_id || p.id,
          price: p.price ? p.price / 100 : 0,
          quantity: p.quantity || 1,
          page_url: window.location.href,
          page_type: getPageType()
        });
      }
    });

    // Track product page view
    const meta = window.ShopifyAnalytics?.meta;
    if (getPageType() === 'product' && meta?.product) {
      track('product:view', {
        product_id: meta.product.id,
        product_name: meta.product.title,
        product_handle: meta.product.handle,
        price: meta.product.variants?.[0]?.price / 100 || 0,
        vendor: meta.product.vendor,
        product_type: meta.product.type
      });
    }

    // Track collection page view
    if (getPageType() === 'collection' && meta?.page) {
      const handle = window.location.pathname.split('/collections/')[1]?.split('/')[0]?.split('?')[0];
      track('collection:view', {
        collection_id: meta.page.resourceId || '',
        collection_handle: handle || '',
        collection_title: document.title.split(' – ')[0] || '',
        products_count: document.querySelectorAll('product-card').length
      });
    }

    // Track promotion card clicks
    document.addEventListener('click', function(e) {
      const promoCard = e.target.closest('.product-card-promotion');
      if (promoCard) {
        const link = promoCard.querySelector('.product-card-promotion--link') || promoCard.querySelector('a.button');
        track('promotion:click', {
          title: promoCard.dataset.title || 'unknown',
          position: promoCard.dataset.position || 'unknown',
          destination: link ? link.href : window.location.href
        });
      }
    });

    // Track upsell product clicks
    document.addEventListener('click', function(e) {
      const productCard = e.target.closest('product-card');
      if (!productCard) return;

      const sectionType = getSectionType(productCard);
      if (sectionType) {
        const productGid = productCard.dataset.productGid || '';
        const productId = productGid.split('/').pop();
        const titleEl = productCard.querySelector('.product-card-title a, .product-card-title');
        const priceEl = productCard.querySelector('.product-card-price .amount, .product-card-price');

        track('upsell:click', {
          section: sectionType,
          product_id: productId,
          product_name: titleEl ? titleEl.textContent.trim() : '',
          price: priceEl ? parseFloat(priceEl.textContent.replace(/[^\d.,]/g, '').replace(',', '.')) : 0,
          page_type: getPageType()
        });
      }
    });

    // Track newsletter submit
    const newsletterForm = document.querySelector('#newsletter form, .email-signup form');
    if (newsletterForm) {
      newsletterForm.addEventListener('submit', function() {
        track('newsletter:submit', { source: 'homepage', success: true });
      });
    }

    // Track FOMO popup clicks
    document.addEventListener('click', function(e) {
      const fomoMessage = e.target.closest('.product--flash-message');
      if (fomoMessage) {
        const productName = fomoMessage.querySelector('.product--flash-message-heading');
        const link = fomoMessage.querySelector('a');
        track('fomo:click', {
          product_id: link ? link.href.split('/').pop() : 'unknown',
          product_name: productName ? productName.textContent.trim() : 'unknown'
        });
      }
    });
  }

  // Public API for bundle tracking
  window.bmTracking = {
    track: track,
    saveDistinctIdToCart: saveDistinctIdToCart,
    bundleView: (handle, collection) => track('bundle:view', { bundle_handle: handle, collection }),
    bundleProductAdd: (product, count) => track('bundle:product_add', { product_id: product.id, product_name: product.title, price: product.price, current_count: count }),
    bundleProductRemove: (productId, count) => track('bundle:product_remove', { product_id: productId, current_count: count }),
    bundleMilestone: (milestone, discountType, totalItems) => track('bundle:milestone_reached', { milestone, discount_type: discountType, total_items: totalItems }),
    bundleAddToCart: (totalItems, totalPrice, discountAmount) => track('bundle:add_to_cart', { total_items: totalItems, total_price: totalPrice, discount_amount: discountAmount }),
    newsletterSubmit: (source, success) => track('newsletter:submit', { source, success }),
    newsletterPopupClose: (seconds) => track('newsletter:popup_close', { time_visible_seconds: seconds }),
    fomoClick: (productId, productName) => track('fomo:click', { product_id: productId, product_name: productName }),
    promotionClick: (title, position, destination) => track('promotion:click', { title, position, destination }),
    upsellClick: (section, product) => track('upsell:click', { section, product_id: product.id, product_name: product.title, price: product.price, page_type: getPageType() }),
    productView: (product) => track('product:view', { product_id: product.id, product_name: product.title, product_handle: product.handle, price: product.price, vendor: product.vendor, product_type: product.type }),
    collectionView: (collection) => track('collection:view', { collection_id: collection.id, collection_handle: collection.handle, collection_title: collection.title, products_count: collection.products_count }),
    addToCart: (product) => track('cart:item_added', { product_id: product.id, product_name: product.title, variant_id: product.variant_id, price: product.price, quantity: product.quantity || 1, page_url: window.location.href, page_type: getPageType() })
  };

  // Wait for PostHog ready event from theme.liquid
  if (window.posthogReady) {
    init();
  } else {
    document.addEventListener('posthog:ready', init);
  }

})();
